import { render, staticRenderFns } from "./SideMenuHeader.vue?vue&type=template&id=4ef1acd2&scoped=true"
import script from "./SideMenuHeader.vue?vue&type=script&lang=js"
export * from "./SideMenuHeader.vue?vue&type=script&lang=js"
import style0 from "./SideMenuHeader.vue?vue&type=style&index=0&id=4ef1acd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef1acd2",
  null
  
)

export default component.exports